export default "__VITE_ASSET__Bfglwn5z__"